module.exports = __webpack_public_path__ + "static/media/phone-footer.9e9e7a93.svg";